import { Injectable } from '@angular/core';
import { PscHttpService } from './psc-http.service';
import { AuthService } from './auth/auth.service';
import { Observable } from 'rxjs';
import { StatData, StatLocation } from '../common/models/statistics/stat-data';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {


  baseEndpoint = 'logger/';

  constructor(
    private httpService: PscHttpService,
    private authService: AuthService,
  ) {
  }

  getStatistics(): Observable<StatData> {
    return this.httpService.get(`${ this.baseEndpoint }statistic`);
  }

  getBusinessStatistics(): Observable<StatLocation[]> {
    return this.httpService.get(`${ this.baseEndpoint }statistic/business`);
  }

}
